module.exports = __webpack_public_path__ + "img/exchange-2-zh.138f1b08.png";